module.exports = __webpack_public_path__ + "img/login-back.f44f4f7b.png";